import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./components/App";
import reportWebVitals from "./reportWebVitals";
import { store } from './wms/src/redux/store';
import { Provider } from 'react-redux'; 
import { UIProvider } from './wms/src/context/UIContext'; 

import { CssBaseline, ThemeProvider } from "@mui/material";

import { BrowserRouter as Router } from "react-router-dom";

import { theme } from "./theme";

ReactDOM.render(
  <React.StrictMode>    
    <Provider store={store}> 
      <ThemeProvider theme={theme}>
        
          <UIProvider>
            <CssBaseline />
            <Router>
              <App />
            </Router>
          </UIProvider>
        
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
